import React from 'react'
import {NavLink, Link, useLocation} from 'react-router-dom'
import { useLogout , useGetIdentity, usePermissions} from 'react-admin';

function Header() {
    const logout = useLogout();
    const userIdentity = useGetIdentity();
    const logoutHandle = () => logout();
    const { permissions } = usePermissions()
    let location = useLocation(); 
    return (
        <>
            <header className="header">
                <div className="container siteContainer">
                    <div className="row">
                        <div className="col-3 headLogoCol">
                            <div className="logContent">
                                <a href="/" className="logo">
                                    Plateforme de gestion des opérations
                                    <img src="/images/logo.png" alt="cashIH" className='img-fluid cashihlogo' />
                                </a>
                            </div>
                        </div>
                        <div className="col-8 headMenuCol">
                            <div className="headerMenuInnerCOl">
                                <div className="menuContent">
                                    <ul className="resetList menuList">
                                        <li className="eventmenu"><NavLink  to="/case-content" className={`nav-link ${location.pathname === "/" ? "active" : ""}`} activeclassname="active"><span>Bibliothèque de contenus</span></NavLink></li>
                                        <li><NavLink  to="/farm-forum" activeclassname="active" className="nav-link"><span>FARM FORUM</span></NavLink ></li>
                                        {/* <li className="hivermenu"><NavLink  to="/hivernage" activeclassname="active" className="nav-link"><span>hivernage</span></NavLink></li> */}
                                        <li className="partsservicemenu"><NavLink  to="/parts-and-service" activeclassname="active" className="nav-link"><span>Parts & Service</span></NavLink></li>
                                    </ul>
                                </div>
                                <div className='userDetail'>
                                <div className='userDetailCnt'>
                                    <p className='userEmail m-0'>{userIdentity?.data?.fullName}
                                        <span className='userEmailAdd'>{userIdentity?.data?.email}</span>
                                    </p>
                                </div>
                                <div className="logoutBtnCnt">
                                    <button className="btn logoutBtn" type="button" onClick={() => logoutHandle()}>
                                        <i className="iconmoon icon-icon_logout logDetails"></i>
                                    </button>
                                </div>
                                {permissions === 'Admin' ?
                                <>
                                    <div className="adminPageBtn">
                                        <NavLink to="/admin" activeclassname="active" className="nav-link"><span>Admin</span></NavLink >
                                    </div>
                                </> : null}
                                </div>
                            </div>
                            <img src="/images/startImg.png" className="img-fluid starImg"  />
                        </div>
                    </div>
                </div>
            </header>

        </>
    );
  }
export default Header;
